import { FilterConfig, FilterValue } from '@/types/filter'

const priority = (): Array<FilterConfig> => {
  return [
    {
      description: '',
      from: {
        maxValue: 10_000_000,
        minValue: 0,
        placeholder: '€ - -',
        step: 5000,
      },
      includeThousandsSeparator: true,
      isRange: true,
      label: 'price',
      name: 'byPrice',
      prefix: '€ ',
      span: '€',
      suffix: '',
      thousandsSeparatorSymbol: '.',
      to: {
        maxValue: 10_000_000,
        minValue: 0,
        placeholder: '€ - -',
        step: 5000,
      },
      trendy: true,
      type: 'money',
    },
    {
      description: '',
      from: {
        maxValue: 10,
        minValue: 0,
        placeholder: '-',
        step: 1,
      },
      isRange: true,
      label: 'rooms',
      name: 'byRooms',
      to: {
        maxValue: 10,
        minValue: 0,
        placeholder: '-',
        step: 1,
      },
      trendy: true,
      type: 'number',
    },
    {
      description: '',
      from: {
        maxValue: 1000,
        minValue: 0,
        placeholder: '- - m²  ',
        step: 1,
      },
      includeThousandsSeparator: false,
      isRange: true,
      label: 'surface',
      name: 'byArea',
      prefix: '',
      span: '  m²  ',
      suffix: ' m²',
      to: {
        maxValue: 1000,
        minValue: 0,
        placeholder: '- -   m²  ',
        step: 1,
      },
      trendy: true,
      type: 'money',
    },
  ]
}

const getServicesValues = (): FilterValue[] => [
  { icon: 'elevator', key: 'onlyWithElevator', value: 'elevator' },
  { icon: 'parkingSpaces', key: 'onlyWithParking', value: 'parkingSpaces' },
  { icon: 'box', key: 'onlyWithBox', value: 'box' },
  { icon: 'basement', key: 'onlyWithBasement', value: 'cellar' },
  { icon: 'garden', key: 'onlyWithGarden', value: 'garden' },
  { icon: 'balcony', key: 'onlyWithBalcony', value: 'balcony' },
  { icon: 'terrace', key: 'onlyWithTerrace', value: 'terrace' },
  { icon: 'pool', key: 'onlyWithPool', value: 'pool' },
  { icon: 'coolingSystem', key: 'onlyWithCoolingSystem', value: 'coolingSystem' },
  { icon: 'conciergeService', key: 'onlyWithConciergeService', value: 'conciergeService' },
]

const others = (): Array<FilterConfig> => {
  return [
    {
      description: 'Tipologia',
      label: 'typology',
      multi: true,
      name: 'byResidentialType',
      priority: 2,
      trendy: false,
      type: 'button-list',
      values: [
        { key: null, value: 'anyone_choice' },
        { key: 'APARTMENT', value: 'apartment' },
        { key: 'HOUSE', value: 'house' },
        { key: 'TOWNHOUSE', value: 'townhouse' },
        { key: 'VILLA', value: 'villa' },
        { key: 'LOFT', value: 'loft' },
        { key: 'ATTIC', value: 'attic' },
        { key: 'MANSARD', value: 'mansard' },
      ],
    },
    {
      description: 'Camere',
      label: 'bedrooms',
      name: 'byBedrooms',
      priority: 3,
      trendy: false,
      type: 'at-least',
    },
    {
      description: 'Bagni',
      label: 'bathrooms',
      name: 'byBathrooms',
      priority: 4,
      trendy: false,
      type: 'at-least',
    },
    {
      description: 'Piano di ingresso',
      label: 'entrance_floor',
      multi: true,
      name: 'byFloor',
      priority: 5,
      trendy: false,
      type: 'button-list',
      values: [
        { key: null, value: 'anyone_choice' },
        { key: 'BASEMENT', value: 'basement' },
        { key: 'GROUND_FLOOR', value: 'ground_floor' },
        { key: 'MID_FLOOR', value: 'mid_floor' },
        { key: 'LAST_FLOOR', value: 'last_floor' },
      ],
    },
    {
      description: 'Condizioni Immobile',
      label: 'state_of_manteinance',
      multi: true,
      name: 'byStateOfMaintenance',
      priority: 6,
      trendy: false,
      type: 'button-list',
      values: [
        { key: null, value: 'anyone_choice' },
        { key: 'HABITABLE', value: 'habitable_status' },
        { key: 'RENOVATED', value: 'renovated_status' },
        { key: 'NEED_RENOVATION', value: 'need_renovation_status' },
        { key: 'NEW', value: 'new_status' },
        // { key: 'UNDER_CONSTRUCTION', value: 'under_construction_status' },
      ],
    },
    {
      description: 'Stato al rogito',
      label: 'state_at_deed',
      multi: true,
      name: 'byStateAtDeed',
      priority: 7,
      trendy: false,
      type: 'button-list',
      values: [
        { key: null, value: 'anyone_choice' },
        { key: 'OCCUPIED', value: 'OCCUPIED' },
        { key: 'FREE', value: 'FREE' },
        // { key: 'RENTED', value: 'RENTED' },
      ],
    },
    {
      description: 'Servizi',
      label: 'services',
      multi: true,
      priority: 8,
      trendy: false,
      type: 'toggle-list',
      values: getServicesValues(),
    },
    {
      description: 'Riscaldamento',
      label: 'heating_system',
      multi: true,
      name: 'byHeatingSystem',
      priority: 10,
      trendy: false,
      type: 'button-list',
      values: [
        { key: null, value: 'anyone_choice' },
        { key: 'AUTONOMOUS', value: 'AUTONOMOUS' },
        { key: 'SHARED', value: 'SHARED' },
        { key: 'NONE', value: 'NONE' },
      ],
    },
    {
      description: '',
      from: {
        maxValue: 2020,
        minValue: 1800,
        placeholder: '1800',
        step: 1,
      },
      isRange: true,
      label: 'year_of_construction',
      name: 'byConstructionYear',
      span: '',
      to: {
        maxValue: 2020,
        minValue: 1800,
        placeholder: '2020',
        step: 1,
      },
      trendy: false,
      type: 'number',
    },
  ]
}

const zones = (): FilterConfig => ({
  name: 'byZone',
})

const onlyCasavo = (): FilterConfig => ({
  name: 'onlyCasavo',
})

const filtersConfiguration = {
  getServicesValues,
  onlyCasavo,
  others,
  priority,
  zones,
}

export default filtersConfiguration
